import { render, staticRenderFns } from "./process-boxes.vue?vue&type=template&id=491aefc5&scoped=true"
import script from "./process-boxes.vue?vue&type=script&lang=js"
export * from "./process-boxes.vue?vue&type=script&lang=js"
import style0 from "./process-boxes.vue?vue&type=style&index=0&id=491aefc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491aefc5",
  null
  
)

export default component.exports